import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export interface CancelAnonymizationPayload {
	email: string;
	password: string;
}

export interface CancelAnonymizationResponse {
	message: string;
	status: 'active';
}

export const useCancelAnonymization = () => {
	return useMutation({
		mutationFn: async (payload: CancelAnonymizationPayload) => {
			try {
				return (await api.post<CancelAnonymizationResponse>('/user/anonymization/cancel', payload)).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao reativar a conta');
			}
		},
		onError: (error) =>
			console.error('Erro ao reativar a conta:', getApiErrorMessage(error, 'Erro ao reativar a conta')),
	});
};
